import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { EmailAdminRoutingModule } from './email-admin-routing.module';
import { EmailTemplateDetailsComponent } from './email-template-details/email-template-details.component';
import { EmailTemplatesComponent } from './email-templates/email-templates.component';
import { SendEmailComponent } from './send-email/send-email.component';

import { SharedModule } from '../../../shared';

@NgModule({
  declarations: [EmailTemplatesComponent, EmailTemplateDetailsComponent, SendEmailComponent],
  imports: [CommonModule, SharedModule, EmailAdminRoutingModule],
})
export class EmailAdminModule {}
